import './sidebar.css';
import { Link } from 'react-router-dom';

import {
    LineStyle,
    Timeline,
    TrendingUp,
    PermIdentity,
    Storefront,
    AttachMoney,
    BarChart,
    MailOutline,
    DynamicFeed,
    ChatBubbleOutline,
    WorkOutline,
    Report,
} from '@material-ui/icons';

export default function Sidebar() {
    return (
        <div className='sidebar'>
            <div className="sidebarWrapper">
                <div className="sidebarMenu">
                    <h3 className="sidebarTitle">Dashboard</h3>
                    <ul className="sidebarList">
                        <Link to='/' className='link'>
                            <li className="sidebarListItem active">
                                <LineStyle className='sidebarIcon' />
                                Home
                            </li>
                        </Link>
                        <li className="sidebarListItem">
                            <Timeline className='sidebarIcon' />
                            Analyics
                        </li>
                        <li className="sidebarListItem">
                            <TrendingUp className='sidebarIcon' />
                            Sales
                        </li>
                    </ul>
                </div>
                <div className="sidebarMenu">
                    <h3 className="sidebarTitle">Quick Menu</h3>
                    <ul className="sidebarList">
                        <Link to='/users' className='link'>
                            <li className="sidebarListItem">
                                <PermIdentity className="sidebarIcon" />
                                Users
                            </li>
                        </Link>
                        <Link to='/products' className='link'>
                            <li className="sidebarListItem">
                                <Storefront />
                                Products
                            </li>
                        </Link>
                        <li className="sidebarListItem">
                            <AttachMoney />
                            Transactions
                        </li>
                        <li className="sidebarListItem">
                            <BarChart />
                            Reports
                        </li>
                    </ul>
                </div>
                <div className="sidebarMenu">
                    <h3 className="sidebarTitle">Notifications</h3>
                    <ul className="sidebarList">
                        <li className="sidebarListItem">
                            <MailOutline />
                            Mail
                        </li>
                        <li className="sidebarListItem">
                            <DynamicFeed />
                            Feedback
                        </li>
                        <li className="sidebarListItem">
                            <ChatBubbleOutline />
                            Messages
                        </li>
                    </ul>
                </div>
                <div className="sidebarMenu">
                    <h3 className="sidebarTitle">staff</h3>
                    <ul className="sidebarList">
                        <li className="sidebarListItem">
                            <WorkOutline />
                            Manage
                        </li>
                        <li className="sidebarListItem">
                            <Timeline />
                            Analyics
                        </li>
                        <li className="sidebarListItem">
                            <Report />
                            Reports
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    )
}
